import { ChevronRight, ExternalLink } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

import { VISUAL_TOKENS } from "../styleGuideVisualTokens";

const { colors } = VISUAL_TOKENS;

const linkBase = "rounded-sm outline-none transition-colors focus-visible:ring-2 focus-visible:ring-offset-2";

export function StyleGuideLinksDemo() {
  return (
    <div className="space-y-8 text-sm leading-relaxed text-[#2D3748]">
      <div>
        <p className="mb-2 text-xs font-medium text-[#718096]">Inline (no corpo do texto)</p>
        <p>
          Frase de exemplo com uma{" "}
          <a
            href="#"
            className={`font-medium underline-offset-2 hover:underline ${linkBase}`}
            style={{ color: colors.primaryBlue500 }}
            onClick={(event) => event.preventDefault()}
          >
            ligação destacada
          </a>{" "}
          seguida de mais texto neutro.
        </p>
      </div>

      <div>
        <p className="mb-2 text-xs font-medium text-[#718096]">Ligação de ação (destaque)</p>
        <button
          type="button"
          className={`inline-flex items-center gap-0.5 font-medium ${linkBase}`}
          style={{ color: colors.primaryBlue500 }}
          onClick={() => undefined}
        >
          Ver tudo
          <ChevronRight className="h-4 w-4 opacity-80" aria-hidden />
        </button>
        <p className="mt-2 text-xs text-[#718096]">
          Usar para ações secundárias ao lado de um título; manter contraste no hover.
        </p>
      </div>

      <div>
        <p className="mb-2 text-xs font-medium text-[#718096]">Navegação interna</p>
        <p>
          <Link
            to="/style-guide"
            className={`font-medium underline-offset-2 hover:underline ${linkBase}`}
            style={{ color: colors.primaryBlue600 }}
          >
            Voltar ao topo desta página
          </Link>
        </p>
      </div>

      <div>
        <p className="mb-2 text-xs font-medium text-[#718096]">Externa (nova janela)</p>
        <a
          href="https://example.com"
          target="_blank"
          rel="noopener noreferrer"
          className={`inline-flex items-center gap-1 font-medium underline-offset-2 hover:underline ${linkBase}`}
          style={{ color: colors.primaryBlue500 }}
        >
          Site de exemplo
          <ExternalLink className="h-3.5 w-3.5 shrink-0 opacity-80" aria-hidden />
        </a>
      </div>

      <div>
        <p className="mb-2 text-xs font-medium text-[#718096]">Discreta (contexto secundário)</p>
        <a
          href="#"
          className={`text-[13px] underline-offset-2 hover:underline ${linkBase}`}
          style={{ color: colors.greyscaleGrey600 }}
          onClick={(event) => event.preventDefault()}
        >
          Saiba mais
        </a>
      </div>

      <div>
        <p className="mb-2 text-xs font-medium text-[#718096]">Estado inativo</p>
        <span className="cursor-not-allowed text-[#A0AEC0]" aria-disabled>
          Indisponível
        </span>
      </div>
    </div>
  );
}
